import { useAppSelector } from 'store/store';
import { footerTaxoLinkColumnsSelector, footerClientLoadingSelector } from 'store/selectors';
import ErrorBoundaryWithLogger from 'components/common/ErrorBoundary/ErrorBoundary';
import MobileAccordion from './MobileAccordion';

const MobileAccordionContainer = () => {
  const columns = useAppSelector(footerTaxoLinkColumnsSelector);
  const isLoading = useAppSelector(footerClientLoadingSelector);

  if (!columns && isLoading) {
    return null;
  }

  if (!columns) {
    throw new Error(
      'Homr did not return any "Footer Links" csvData content. Make sure the correct data is being returned! ',
    );
  }
  return (
    <ErrorBoundaryWithLogger componentId="Footer-MobileAccordion">
      <MobileAccordion links={columns} />
    </ErrorBoundaryWithLogger>
  );
};

export default MobileAccordionContainer;
